import { render, staticRenderFns } from "./SidebarProduct.vue?vue&type=template&id=0ce937aa&scoped=true&"
import script from "./SidebarProduct.vue?vue&type=script&lang=js&"
export * from "./SidebarProduct.vue?vue&type=script&lang=js&"
import style0 from "./SidebarProduct.vue?vue&type=style&index=0&id=0ce937aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce937aa",
  null
  
)

export default component.exports